import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from './assets/Logo.png';
import "./AddCar.css";

function AddCarVIN() {
  const [vin, setVin] = useState("");
  const [carInfo, setCarInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // دریافت اطلاعات کاربر از localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      setUser({
        name: parsed.Name,
        email: parsed.Email,
        phone: parsed.Phone,
        address: parsed.Address,
        postalCode: parsed["Postal Code"]
      });
    }
  }, []);

  const handleVINSearch = async () => {
    if (vin.length < 11) {
      alert("❌ VIN must be at least 11 characters.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${vin}?format=json`);
      const data = await res.json();
      const result = data.Results[0];

const trim = `${result.Trim || result.Series || "Unknown"} ${result.DisplacementL || ""}L ${result.ElectrificationLevel?.split(" ")[0] || ""}`.trim();

const extracted = {
  brand: result.Make,
  model: result.Model,
  year: result.ModelYear,
  trim
};


      if (!extracted.brand || !extracted.model || !extracted.year) {
        alert("❌ Could not retrieve full car data. Please try another VIN.");
        setCarInfo(null);
      } else {
        setCarInfo(extracted);
      }
    } catch (error) {
      console.error("Error fetching VIN data:", error);
      alert("Error fetching VIN data. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!user || !carInfo) return;
    try {
      const res = await fetch("https://carcure.ca/backend/save-car", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          brand: carInfo.brand,
          model: carInfo.model,
          year: carInfo.year,
          trim: carInfo.trim
        })
      });
      const data = await res.json();
      alert(data.message);
      if (data.message.includes("✅")) {
        navigate("/customer-dashboard");
      }
    } catch (error) {
      console.error("Error saving car:", error);
      alert("❌ Failed to save the car.");
    }
  };

  return (
    <>
      <header className="header-addcar">
        <img src={logo} alt="Logo" className="header-logo" />
      </header>

      <div className="main-container">
        <div className="CarSelection">
          <h1>🔍 Add Car by VIN</h1>
          <hr />
          <p>Please enter your 17-character VIN code:</p>
          <input
            type="text"
            value={vin}
            onChange={(e) => setVin(e.target.value.toUpperCase())}
            placeholder="Enter VIN (e.g. 1HGCM82633A123456)"
            maxLength={17}
            className="vin-input"
          />
          <button className="confirm-button" onClick={handleVINSearch} disabled={loading}>
            {loading ? "Searching..." : "Search VIN"}
          </button>

          {carInfo && (
            <div className="vin-result">
              <h3>🚘 Vehicle Details</h3>
              <p><strong>Brand:</strong> {carInfo.brand}</p>
              <p><strong>Model:</strong> {carInfo.model}</p>
              <p><strong>Year:</strong> {carInfo.year}</p>
              <p><strong>Trim:</strong> {carInfo.trim}</p>

              <button className="confirm-button" onClick={handleSave}>✅ Confirm & Save</button>
              <button className="cancel-button" onClick={() => setCarInfo(null)}>❌ Cancel</button>
            </div>
          )}

          <button className="back-button" onClick={() => navigate("/customer-dashboard")}>⬅️ Back to Dashboard</button>
        </div>
      </div>
    </>
  );
}

export default AddCarVIN;
